const ELEMENT_GROUPS = {
  //CRUD: { key: 'crud', label: 'CRUD' },
  TEXT: { key: 'text', label: 'Text' },
  MEDIA: { key: 'media', label: 'Media' },
  FORMS: { key: 'forms', label: 'Inputs' },
  LISTS: { key: 'lists', label: 'Lists' },
  NAVIGATION: { key: 'nav', label: 'Nav' },
  LAYOUTS: { key: 'layouts', label: 'Layouts' },
  OTHER: { key: 'other', label: 'Other' },
  AUTH: { key: 'auth', label: 'Auth' }
};

const ELEMENT_ATTRIBUTE_GROUP = {
  BEHAVIOUR: 'behaviour',
  COLORS: 'colors',
  IMAGERY: 'imagery',
  VISIBILITY: 'visibility',
  LAYOUT: 'layout',
  FONTS: 'fonts',
  CONTENT: 'content',
  HTML: 'html',
  STYLE: 'style'
};

const markupDescription =
  'Static text or placeholder markup. ${source...} is deprecated. Valid placeholders are: {field} where field is from the data source that this element is bound to, or {user.field} {local.field.field...}, {ds.datasourceId.field} where datasourceId is replaced with the id of a datasource, formatDate("{anyplaceholder}","MMMM i.e. a momentjs format") or inline condition if("{anyplaceholder}" === "green" ? "ok": "cancel") or any combinations of the above that form a sentence for example.';

export { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS, markupDescription };
